export default "__VITE_ASSET__8cO_rbkG__"